/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentAdminControllerPreviewStuckProcessingsQueryResponse, DocumentAdminControllerPreviewStuckProcessingsQueryParams, DocumentAdminControllerPreviewStuckProcessings400, DocumentAdminControllerPreviewStuckProcessings401, DocumentAdminControllerPreviewStuckProcessings403, DocumentAdminControllerPreviewStuckProcessings404 } from "../../models/documentAdminController/DocumentAdminControllerPreviewStuckProcessings";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { documentAdminControllerPreviewStuckProcessings } from "../../clients/document-adminService/documentAdminControllerPreviewStuckProcessings";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const documentAdminControllerPreviewStuckProcessingsQueryKey = (params: DocumentAdminControllerPreviewStuckProcessingsQueryParams = {}) => [{
  url: '/api/v1/documents/stuck-processings/preview'
}, ...(params ? [params] : [])] as const;
export type DocumentAdminControllerPreviewStuckProcessingsQueryKey = ReturnType<typeof documentAdminControllerPreviewStuckProcessingsQueryKey>;
export function documentAdminControllerPreviewStuckProcessingsQueryOptions(params?: DocumentAdminControllerPreviewStuckProcessingsQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = documentAdminControllerPreviewStuckProcessingsQueryKey(params);
  return queryOptions<DocumentAdminControllerPreviewStuckProcessingsQueryResponse, ResponseErrorConfig<DocumentAdminControllerPreviewStuckProcessings400 | DocumentAdminControllerPreviewStuckProcessings401 | DocumentAdminControllerPreviewStuckProcessings403 | DocumentAdminControllerPreviewStuckProcessings404>, DocumentAdminControllerPreviewStuckProcessingsQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return documentAdminControllerPreviewStuckProcessings(params, config);
    }
  });
}

/**
 * @description Admin/service-account endpoint. Read-only: detects processings that are non-terminal but will never finish — job FAILED, no live job anywhere (after a grace period), all steps terminal without finalization, a RUNNING step past its own budget, or the whole run past its timeout — and returns them with step and job context without changing any data. A job claiming a live worker suppresses the JOB_FAILED signal (a rerun is in flight) but no step-side evidence — such rows are returned flagged hasActiveWorker. Use this to see what a cancel would do before approving it, and again afterwards to verify.
 * @summary Preview processings stuck in non-terminal states
 * {@link /api/v1/documents/stuck-processings/preview}
 */
export function useDocumentAdminControllerPreviewStuckProcessings<TData = DocumentAdminControllerPreviewStuckProcessingsQueryResponse, TQueryData = DocumentAdminControllerPreviewStuckProcessingsQueryResponse, TQueryKey extends QueryKey = DocumentAdminControllerPreviewStuckProcessingsQueryKey>(params?: DocumentAdminControllerPreviewStuckProcessingsQueryParams, options: {
  query?: Partial<QueryObserverOptions<DocumentAdminControllerPreviewStuckProcessingsQueryResponse, ResponseErrorConfig<DocumentAdminControllerPreviewStuckProcessings400 | DocumentAdminControllerPreviewStuckProcessings401 | DocumentAdminControllerPreviewStuckProcessings403 | DocumentAdminControllerPreviewStuckProcessings404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? documentAdminControllerPreviewStuckProcessingsQueryKey(params);
  const query = useQuery({
    ...documentAdminControllerPreviewStuckProcessingsQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DocumentAdminControllerPreviewStuckProcessings400 | DocumentAdminControllerPreviewStuckProcessings401 | DocumentAdminControllerPreviewStuckProcessings403 | DocumentAdminControllerPreviewStuckProcessings404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}